import * as bootstrap from 'bootstrap'

// init gallery lightbox with carousel
const initGallery = () => {
  const modal = document.getElementById('modalGalleryLightbox');
  if (!modal) return;

  const carouselEl = modal.querySelector('#galleryCarousel');
  if (!carouselEl) return;

  // create or get bootstrap carousel instance
  const carousel = bootstrap.Carousel.getOrCreateInstance(carouselEl, {
    interval: false,
    ride: false,
    wrap: true,
    touch: true,
    keyboard: true,
  });

  // when modal opens -> jump to clicked image
  modal.addEventListener('show.bs.modal', (event) => {
    const triggerBtn = event.relatedTarget;
    const index = parseInt(triggerBtn?.getAttribute('data-index') || '0', 10);
    const max = carouselEl.querySelectorAll('.carousel-item').length - 1;
    const safeIndex = Math.max(0, Math.min(index, max));

    carousel.to(safeIndex);
  });

  // when modal closes -> stop carousel
  modal.addEventListener('hidden.bs.modal', () => {
    carousel.pause();
  });
};

export default initGallery;
